import { DollarSign, ShoppingCart, Users } from 'lucide-react';
import { StatCard } from './management/statcard';
import { SalesChart } from './management/saleschart';


//const UcOverview = () => {
function UcOverview() {
  
  return (
    <main style={{ flex: 1, padding: '24px' }}>
      <div style={{ maxWidth: '1280px', margin: '0 auto' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '24px',
          marginBottom: '24px',
        }}>
          <StatCard
            title="Total Revenue"
            value="$45,231"
            change="12.5%"
            trend="up"
            icon={DollarSign}
            iconColor="bg-blue-500"
          />
          <StatCard
            title="Total Orders"
            value="1,234"
            change="8.2%"
            trend="up"
            icon={ShoppingCart}
            iconColor="bg-green-500"
          />
          <StatCard
            title="Total Customers"
            value="3,456"
            change="3.1%"
            trend="down"
            icon={Users}
            iconColor="bg-purple-500"
          />
        </div>
        
        <SalesChart />
      </div>
    </main>
  );

}

export default UcOverview;